import { merge, reduce, get, set } from 'lodash'

export const chainValidators = validators => (values, props) => {
  const errors = reduce(
    validators,
    (result, v) => merge(result, v(values, props)),
    {}
  )
  return errors
}

export const requiredFieldsValidatorFactory = fields => values => {
  const errors = {}
  fields.forEach(field => {
    const value = get(values, field)
    if (!value) {
      set(errors, field, 'Required')
    } else {
      if (Array.isArray(value)) {
        if (!value[0]) {
          set(errors, `${field}[0]`, 'Required')
        }
      }
    }
  })
  return errors
}



// WEBPACK FOOTER //
// ./src/utils/validators.js